var React = require('react');

function Voicemail (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M496 224a48 48 0 1 0 48 48 48.05 48.05 0 0 0-48-48zm-352 0a48 48 0 1 0 48 48 48.05 48.05 0 0 0-48-48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z","className":"fa-primary","key":2})]);
}

Voicemail.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Voicemail;

Voicemail.default = Voicemail;
